import {Utils} from "./Utils";
import * as keyboardjs from 'keyboardjs';

var clipboard = require('clipboard');

interface ILogger {
    supportGroups: boolean;

    debug(...args: any[]): void;
    error(msg: string, ...args: any[]): void;
    warn(...args: any[]): void;

    groupStart(groupTitle: string): void;
    groupEnd(): void;
}

class ConsoleLogger implements ILogger {
    private _supportGroups: boolean = null;

    get supportGroups(): boolean {
        if (this._supportGroups === null) {
            this._supportGroups = console.groupEnd !== undefined &&
                console.groupCollapsed !== undefined &&
                console.group !== undefined;
        }

        return this._supportGroups;
    }

    debug(...args: any[]): void {
        console.log.apply(console, [].slice.call(args, 0));
    }

    error(msg: string, ...args: any[]): void {
        console.error(msg, [].slice.call(args, 0));
    }

    warn(...args: any[]): void {
        if (console.warn) {
            console.warn.apply(console, [].slice.call(args, 0));
        }
    }

    groupStart(groupTitle: string): void {
        if (this.supportGroups) {
            console.group(groupTitle);
        }
    }

    groupEnd(): void {
        if (this.supportGroups) {
            console.groupEnd();
        }
    }
}

class DomElementLogger implements ILogger {
    private _elementId: string;
    private _elementInnerId: string;
    private _element: HTMLDivElement;
    private _elementInner: HTMLDivElement;
    private _elementContainer: HTMLDivElement;
    private _btnClear: HTMLAnchorElement;
    private _btnHide: HTMLAnchorElement;
    private _btnCopy: HTMLAnchorElement;
    private _pausedLogging: boolean;

    constructor() {
        this.toggleHideShow = this.toggleHideShow.bind(this);
        this.clearLogger = this.clearLogger.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);

        this._pausedLogging = false;
        this._elementId = '__NeoLogger';
        this._elementInnerId = this._elementId + '-inner';
        this._element = document.getElementById(this._elementId) as HTMLDivElement;

        if (Utils.isNullOrUndefined(this._element)) {
            this._element = document.createElement("div");
            this._element.setAttribute('id', this._elementId);

            this._element.innerHTML =
                `<div id="__NeoLogger-header">
                   <span>Logger</span>
                   <a href="javascript:void(0)" id="__NeoLogger-header-clear" title="Shortcut: Ctrl+Shift+9">clear</a>
                   <a href="javascript:void(0)" id="__NeoLogger-header-copy" title="Shortcut: Ctrl+Shift+C" style="margin-right: 5px;">[C]</a>
                   <a href="javascript:void(0)" id="__NeoLogger-header-hide" title="Shortcut: Ctrl+Shift+1" style="margin-right: 5px;">hide</a>
                 </div>
                 <div id="__NeoLogger-container" class="logger-container">
                    <div id="${this._elementInnerId}"></div>
                 </div>`;

            document.body.appendChild(this._element);

            this._btnClear = document.getElementById('__NeoLogger-header-clear') as HTMLAnchorElement;
            this._btnHide = document.getElementById('__NeoLogger-header-hide') as HTMLAnchorElement;
            this._btnCopy = document.getElementById('__NeoLogger-header-copy') as HTMLAnchorElement;

            var self = this;
            this._btnClear.onclick = this.clearLogger;

            new clipboard('#__NeoLogger-header-copy', {
                text: function (trigger: any) {
                    return self._elementInner.innerText;
                }
            });


            this._btnHide.onclick = this.toggleHideShow;
        }

        this._elementInner = document.getElementById(this._elementInnerId) as HTMLDivElement;
        this._elementContainer = document.getElementById('__NeoLogger-container') as HTMLDivElement;

        keyboardjs.bind('ctrl+shift+1', this.toggleHideShow);
        keyboardjs.bind('ctrl+shift+9', this.clearLogger);
        keyboardjs.bind('ctrl+shift+c', this.copyToClipboard);

        //this.toggleHideShow();
    }

    private copyToClipboard(): void {
        this._btnCopy.click();
    }

    private clearLogger(): void {
        this._elementInner.innerHTML = '';
    }

    private toggleHideShow(): void {
        var containerHidden = this._elementContainer.style.display === 'none';

        this._elementContainer.style.display = containerHidden ? 'block' : 'none';
        this._btnClear.style.display = containerHidden ? 'block' : 'none';
        this._btnHide.innerText = containerHidden ? 'hide' : 'show';
        this._element.style.width = containerHidden ? null : '100px';

        this._pausedLogging = !containerHidden;
    }

    scrollToBottom(): void {
        if (this._elementInner) {
            this._elementInner.scrollIntoView(false);
        }
    }

    get supportGroups(): boolean {
        return false;
    }

    debug(...args: any[]): void {
        this.log('debug', ...args);
    }

    error(msg: string, ...args: any[]): void {
        this.log('error', msg, ...args);
    }

    warn(...args: any[]): void {
        this.log('warn', ...args);
    }

    private log(logType: 'debug' | 'warn' | 'error', ...args: any[]): void {
        if (this._pausedLogging) {
            return;
        }

        var elem = this._elementInner;
        var isErrorOrWarn = logType === 'warn' || logType === 'error';

        var html = elem.innerHTML;
        if (isErrorOrWarn) {
            var color = logType === 'warn' ? 'orange' : 'red';
            html += `<span style="color: ${color}">`;
        }

        for (var i = 1; i < arguments.length; i++) {
            if (typeof arguments[i] == 'object') {
                var iserr = arguments[i] instanceof Error;
                if (iserr) {
                    var err = arguments[i] as Error;
                    html += `${err.message}, ${err.stack}`;
                } else {
                    html += (JSON && JSON.stringify ? JSON.stringify(arguments[i], undefined, 2) : arguments[i]) + '<br />';
                }
            } else {
                //html += arguments[i] + '<br />';

                let item = arguments[i].replace(/\r|\n/, () => {
                    return '<br/>';
                });

                html += item + '<br />';
            }
        }

        if (isErrorOrWarn) {
            html += '</span>';
        }

        elem.innerHTML = html;

        this.scrollToBottom();
    }

    groupStart(groupTitle: string): void {
    }

    groupEnd(): void {
    }
}

export class Logger {
    private static _currentGroup: string = null;
    private static _impl: ILogger = null;

    private static get impl(): ILogger {
        var changeLoggerRequested = !!window['NEO-CHANGE-LOGGER'];
        if (changeLoggerRequested) {
            Logger._impl = null;
        }

        if (Utils.isNullOrUndefined(Logger._impl)) {
            var domLogger = !!window['NEO-DOM-LOGGER'];
            Logger._impl = domLogger ? new DomElementLogger() : new ConsoleLogger();
        }

        return Logger._impl;
    }

    private static get supportGroups(): boolean {
        return Logger.impl.supportGroups;
    }

    public static debug(...args: any[]) {
        Logger.closeGroup();
        Logger.impl.debug(...args);
    }

    public static error(msg: string, e?: Error | string, ...args: any[]) {
        Logger.closeGroup();
        Logger.impl.error(msg, e, ...args);
    }

    public static warn(...args: any[]) {
        Logger.closeGroup();
        Logger.impl.warn(...args);
    }

    private static closeGroup(): void {
        if (Logger.supportGroups && Logger._currentGroup !== null) {
            Logger.impl.groupEnd();
            Logger._currentGroup = null;
        }
    }

    public static debugGroup(group: string, ...args: any[]) {
        if (Logger.supportGroups) {
            if (Logger._currentGroup !== group) {
                Logger.impl.groupEnd();
                Logger.impl.groupStart(Logger._currentGroup = group);
            }
            Logger.impl.debug(...args);
        } else {
            Logger.debug(`[${group}]`, ...args);
        }
    };

    public static errorGroup(group: string, e: Error | string, ...args: any[]) {
        if (Logger.supportGroups) {
            if (Logger._currentGroup !== group) {
                Logger.impl.groupEnd();
                Logger.impl.groupStart(Logger._currentGroup = group);
            }
            Logger.impl.error(e as any, ...args);
        } else {
            Logger.error(`[${group}]`, e, ...args);
        }
    };

    public static warnGroup(group: string, ...args: any[]) {
        if (Logger.supportGroups) {
            if (Logger._currentGroup !== group) {
                Logger.impl.groupEnd();
                Logger.impl.groupStart(Logger._currentGroup = group);
            }
            Logger.impl.warn(...args);
        } else {
            Logger.warn(`[${group}]`, ...args);
        }
    };
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/Logger.ts
 **/